export default {
  tabMenu: {
    audit: 'Audit',
    auditConfiguration: 'Audit-Spezifikationen',
    quality: 'Qualität',
    qualityConfiguration: 'Qualitätseinstellungen',
    qualityStatistics: 'Qualitätsstatistik',
  },
};
